<template>
    <AuditsContainer />
</template>

<script>
    // vuex
    import {mapActions} from "vuex";
    import {REFRESH_TOKEN} from "../store/actions/auth";
    // components
    import AuditsContainer from "../components/reports/AuditsContainer";
    import {setDocumentTitle} from "@/utils/i18n/document";

    export default {
        name: "ReportsView",
        components: {
            AuditsContainer
        },
        async mounted() {
            setDocumentTitle(this.$t("reports.title"));
            await this.REFRESH_TOKEN();
        },
        methods: {
            ...mapActions([REFRESH_TOKEN])
        }
    }
</script>

<style>
</style>